module.exports = __webpack_public_path__ + "static/media/title_hourglass_red8d39fc935192f57d72b4da3b73a91df1.webp";